export default ({color, size}) =>
  <svg xmlns="http://www.w3.org/2000/svg" className="icon"
       viewBox="0 0 1024 1024" version="1.1" width={size} height={size}>
    <path
      d="M0 877.714286h1024v146.285714H0zM95.085714 548.571429L0 438.857143l460.8-365.714286 358.4 351.085714L1024 219.428571v512H504.685714l204.8-204.8-256-256z"
      fill={ color}/>
  </svg>
;
